var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "BjDrawerForm",
        {
          ref: "BjDrawerForm",
          attrs: {
            form: _vm.form,
            "confirm-dis": _vm.isView,
            width: "800px",
            "label-width": "120px",
          },
          on: { handleConfirm: _vm.handleConfirm },
        },
        [
          _c(
            "BjDivider",
            [
              _vm._v(_vm._s(_vm.$t("AccountManagement.work.info")) + " "),
              _c(
                "template",
                { slot: "right" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", disabled: _vm.isView },
                      on: {
                        click: function ($event) {
                          return _vm.onAddStaff()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("addText")))]
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "el-form",
            {
              ref: "staffList",
              attrs: { model: _vm.form, rules: _vm.staffListRules },
            },
            [
              _c(
                "el-table",
                { attrs: { data: _vm.form.staffList, stripe: "", border: "" } },
                [
                  _c("el-table-column", {
                    attrs: {
                      type: "index",
                      label: _vm.$t("DetailsOfThirdPartySalesOrder.Serial"),
                      align: "center",
                      width: "60",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "header",
                        fn: function () {
                          return [
                            _vm._v(
                              _vm._s(_vm.$t("AccountManagement.staff.name"))
                            ),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          var $index = ref.$index
                          return [
                            _c(
                              "el-form-item",
                              {
                                staticStyle: {
                                  "margin-top": "10px !important",
                                },
                                attrs: {
                                  prop: "staffList." + $index + ".name",
                                  rules: _vm.staffListRules.name,
                                },
                              },
                              [_c("span", [_vm._v(_vm._s(row.name))])]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "header",
                        fn: function () {
                          return [
                            _c("span", { staticClass: "red" }, [_vm._v("*")]),
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("AccountManagement.work.hour"))
                            ),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          var $index = ref.$index
                          return [
                            _c(
                              "el-form-item",
                              {
                                staticStyle: {
                                  "margin-top": "10px !important",
                                },
                                attrs: {
                                  prop:
                                    "staffList." + $index + ".staffListHours",
                                  rules: _vm.staffListRules.staffListHours,
                                },
                              },
                              [
                                _c("el-time-picker", {
                                  staticClass: "full-width",
                                  attrs: {
                                    format: "HH:mm",
                                    "value-format": "yyyy-MM-dd HH:mm:ss",
                                    "is-range": "",
                                    "range-separator": "-",
                                    "start-placeholder":
                                      _vm.$t("form.startTimeText"),
                                    "end-placeholder":
                                      _vm.$t("form.endTimeText"),
                                    disabled: _vm.isView,
                                  },
                                  model: {
                                    value: row.staffListHours,
                                    callback: function ($$v) {
                                      _vm.$set(row, "staffListHours", $$v)
                                    },
                                    expression: "row.staffListHours",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("BusinessThirdOrderAdd.form.Operation"),
                      align: "center",
                      fixed: "right",
                      width: "120",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text", disabled: _vm.isView },
                                on: {
                                  click: function ($event) {
                                    return _vm.onDelete(scope.$index)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("delText")))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("BjDivider", [
            _vm._v(_vm._s(_vm.$t("AccountManagement.work.Reason"))),
          ]),
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("AccountManagement.work.Reason"),
                    prop: "reason",
                  },
                },
                [
                  _c("BjInput", {
                    attrs: {
                      type: "textarea",
                      "show-word-limit": "",
                      maxlength: _vm.MAX_LENGTH.PRIORITY,
                      autosize: "",
                      placeholder: _vm.$t("AccountManagement.work.Reason"),
                      clearable: "",
                      disabled: _vm.isView,
                    },
                    model: {
                      value: _vm.form.reason,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "reason", $$v)
                      },
                      expression: "form.reason",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("BjLogTableDialog", {
        ref: "logTable",
        attrs: {
          "query-api": _vm.queryApi,
          "query-params": _vm.queryParams,
          "staff-role-list": _vm.staffRoleList,
          "staff-dept-list": _vm.staffDeptList,
        },
        on: { onConfirm: _vm.onConfirm },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: 6 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("AccountManagement.staff.name"),
                          prop: "staffName",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            placeholder: _vm.$t("AccountManagement.staff.name"),
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.staffName,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "staffName", $$v)
                            },
                            expression: "queryParams.staffName",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 6 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("AccountManagement.staff.department"),
                          prop: "staffDepartment",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.staffDeptList,
                            placeholder: _vm.$t(
                              "AccountManagement.staff.department"
                            ),
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.queryParams.staffDepartment,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "staffDepartment", $$v)
                            },
                            expression: "queryParams.staffDepartment",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }